export default __webpack_public_path__ + "static/media/promo-how-far-will-fudge-go_02.3fcfd712.jpg";